import { SmartLib, AdManager } from '@broadpeak/smartlib';
import '@broadpeak/smartlib-ad';
import '@broadpeak/smartlib-analytics';
import '@broadpeak/smartlib-connectplayer';
import '@broadpeak/smartlib-monitoring';
import '@broadpeak/smartlib-nanocdn';

let isSmartLibInit = false
let streamingSession: any;

declare const goog: any;

export const createSession = (broadpeakConfig: any, player: any) => {
    if(!broadpeakConfig.enable) {
        return {}
    }

    if(!isSmartLibInit) {
        SmartLib.getInstance().init(broadpeakConfig.analyticsAddress, '', broadpeakConfig.broadpeakDomainNames);
        isSmartLibInit = true;

        // Attach PAL SDK (if using Google)
        if (broadpeakConfig.adsEnable) {
            AdManager.getInstance().attachPALSDK(goog);
        }
    }

    streamingSession = SmartLib.getInstance().createStreamingSession()
    streamingSession.attachPlayer(player)
    return streamingSession;
}

export const getSessionUrl = async (broadpeakConfig: any, source: any) => {
    if(!broadpeakConfig.enable || (!streamingSession && !streamingSession?.getURL)) {
        return source;
    }

    const result = await streamingSession.getURL(source)
    if(result.isError()) {
        stopStreamingSession(result.getErrorCode())
        return null;
    } else {
        return result.url
    }
}

export const getStreamingSession = () => {
    if (!streamingSession) {
        return
    }

    return streamingSession
}

export const isSessionRunning = () => Boolean(streamingSession)

export const stopStreamingSession = (errorCode: string) => {
    if (!streamingSession) {
        return
    }

    console.log('Stopped broadpeak streaming session with code =>', errorCode !== '' ? errorCode : SmartLib.BPSessionEndsNormally)
    streamingSession.stopStreamingSession(errorCode !== '' ? errorCode : SmartLib.BPSessionEndsNormally)
    streamingSession = null
}

export const getBpStreamingErrorCode = (errorCode: string) => {
    switch (errorCode) {
            case '3100':
                return SmartLib.BPAccessRightError
            case '1357':
                return SmartLib.BPDecodingError
            case '3000':
            case '3002':
                return SmartLib.BPAccessRightError
            case '1010':
                return SmartLib.BPFormatNotSupportedError
            case '100':
                return SmartLib.BPNetworkingError
            default:
                return SmartLib.BPUnspecifiedError
        }
}